import { useTranslation } from 'react-i18next';
import FactContainer from './FactContainer';

const FactThree = ({ history }) => {
  const { t } = useTranslation();
  return (
    <FactContainer
      history={history}
      factTitle={t('fact_3')}
      factDescription={{
        __html: t('fact_3_disclaimer'),
      }}
      nextUrl="q21"
      screenName="f3"
    />
  );
};

export default FactThree;
